const MenuItem = [
    {
        title:'Home',
        url: '#',
        cName: 'nav-links',
    },
    {
        title:'About',
        url: '#',
        cName: 'nav-links',
    },
    {
        title:'Menu',
        url: '#',
        cName: 'nav-links',
    },
    {
        title:'Specials',
        url: '#',
        cName: 'nav-links',
    },
    {
        title:'Acoustic Nights',
        url: '#',
        cName: 'nav-links',
    }

]


export default MenuItem